import Gantt from './gantt.vue'
import flatPickr from 'vue-flatpickr-component'

// Styles
import 'flatpickr/dist/flatpickr.css'

const install = (Vue) => {
  Vue.use(require('vue-moment'))
  Vue.component('flatPickr', flatPickr)
  Vue.component('Gantt', Gantt)
}

// Auto-install when used globally
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install,
  Gantt
}

export { Gantt }
